import React, { useEffect, useState, useCallback } from 'react';
import NFT_TEMPLATES from '../config/nftTemplates';
import WORKER_TEMPLATES from '../config/workerTemplates';
import {WORKER_PACK_TEMPLATES} from '../config/workerPackTemplates';
import SEASONS from '../config/seasons';
import './Calculator.css';
import WalletInput from '../components/WalletManager';

import farmIcon from '../assets/icons/farm.webp';
import ranchIcon from '../assets/icons/ranch.webp';
import toolIcon from '../assets/icons/tool.webp';
import waxpIcon from '../assets/icons/waxp.webp';
import rcoinIcon from '../assets/icons/rcoin.webp';
import { getConfigs } from '../api/waxApi';

const TOKEN_INFO = {
    FARM: { id: 945, icon: farmIcon },
    RANCH: { id: 944, icon: ranchIcon },
    TOOL: { id: 946, icon: toolIcon },
    RCOIN: { id: 947, icon: rcoinIcon }
};

const MARKET_NODES = [
    //"wax.api.atomicassets.io",//
    "atomic.wax.eosrio.io", //
    "aa.dapplica.io", //
    "atomic.3dkrender.com", //
    "wax-aa.eu.eosamsterdam.net", //
    "wax-atomic-api.eosphere.io",//
    "wax-atomic.eosiomadrid.io",//
];


const fetchWithFallback = async (path) => {
    const shuffled = [...MARKET_NODES].sort(() => Math.random() - 0.5); // rastgele sırala
    for (let i = 0; i < shuffled.length; i++) {
        const node = `https://${shuffled[i]}`;
        try {
            const res = await fetch(`${node}${path}`, { timeout: 5000 });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (err) {
            console.warn(`Failed on ${node}${path}: ${err.message}`);
        }
    }
    throw new Error(`All MARKET_NODES failed for ${path}`);
};

export default function Calculator() {
    const [tokenData, setTokenData] = useState({});
    const [session, setSession] = useState(null);
    const [fee, setFee] = useState(null);
    const [lowestPrices, setLowestPrices] = useState({});
    const [mintInfo, setMintInfo] = useState({});
    const [waxpUsd, setWaxpUsd] = useState(null);


    const getBuyUrl = (templateId) => {
        return `https://neftyblocks.com/marketplace/listing?template_id=${templateId}&collection_name=ranchersland&sort=price&order=asc&page=1`;
    };

    const fetchLowestPrices = async (waxprice) => {
        const allTemplates = [...NFT_TEMPLATES, ...WORKER_TEMPLATES];
        const newPrices = {};

        for (let i = 0; i < allTemplates.length; i++) {
            const tpl = allTemplates[i];
            //const url = `https://wax-atomic.eosiomadrid.io/atomicmarket/v1/sales/templates?symbol=WAX&collection_name=ranchersland&template_id=${tpl.template_id}&limit=1&order=asc&sort=price`;
            const path = `/atomicmarket/v1/sales/templates?symbol=WAX&collection_name=ranchersland&template_id=${tpl.template_id}&limit=1&order=asc&sort=price`;

            try {
                const json = await fetchWithFallback(path);
                if (json.success && json.data.length > 0) {
                    const sale = json.data[0];
                    let waxAmount = 0;

                    if (sale.listing_symbol === 'WAX') {
                        waxAmount = parseFloat(sale.listing_price) / 100000000;
                    } else if (sale.listing_symbol === 'USD' && waxprice) {
                        waxAmount = (parseFloat(sale.listing_price) / 100) / waxprice;
                    }

                    newPrices[tpl.template_id] = waxAmount;
                }
            } catch (err) {
                console.warn(`Template ${tpl.template_id} fetch error`, err);
            }

            if (i % 5 === 4) await new Promise(res => setTimeout(res, 500));
        }

        setLowestPrices(newPrices);
    };
    const fetchMintInfo = async () => {
        const allTemplates = [...NFT_TEMPLATES, ...WORKER_TEMPLATES];
        const newMintInfo = {};

        for (let i = 0; i < allTemplates.length; i++) {
            const tpl = allTemplates[i];
            //const url = `https://wax-atomic.eosiomadrid.io/atomicassets/v1/templates/ranchersland/${tpl.template_id}`;
            const path = `/atomicassets/v1/templates/ranchersland/${tpl.template_id}`;
            //https://atomic.wax.eosrio.io/atomicmarket/v1/sales/templates?symbol=WAX&collection_name=ranchersland&template_id=890190,890194&limit=100&order=asc&sort=price
            try {
                const json = await fetchWithFallback(path);
                if (json.success && json.data?.issued_supply) {
                    const total = parseInt(json.data.issued_supply);
                    newMintInfo[tpl.template_id] = Math.max(0, total - 1);
                }
            } catch (err) {
                console.warn(`Mint info fetch error for ${tpl.template_id}`, err);
            }

            if (i % 5 === 4) await new Promise(res => setTimeout(res, 500));
        }

        setMintInfo(newMintInfo);
    };
    const fetchData = useCallback(() => {

        fetch('https://api.binance.com/api/v3/ticker/price?symbol=WAXPUSDT')
            .then(res => res.json())
            .then(data => {
                const waxPrice = parseFloat(data.price);
                setWaxpUsd(waxPrice);
                fetchLowestPrices(waxPrice); // BURADA ANINDA ÇAĞIR
            })
            .catch(err => console.warn('Binance price fetch error:', err));
        Object.entries(TOKEN_INFO).forEach(async ([symbol, { id }]) => {
            try {
                const res = await fetch(`https://wax.alcor.exchange/api/markets/${id}`);
                if (!res.ok) throw new Error(`Failed ${symbol} market fetch`);

                const data = await res.json();
                const price = data.last_price;
                const change24 = (data.change24 ?? 0).toFixed(2);
                const change7d = (data.changeWeek ?? 0).toFixed(2);
                const volume24 = Number(data.volume24 ?? 0).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
                const volume7d = Number(data.volumeWeek ?? 0).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });

                setTokenData(prev => ({
                    ...prev,
                    [symbol]: {
                        price,
                        change24,
                        volume24,
                        change7d,
                        volume7d,
                    },
                }));
            } catch (err) {
                console.warn(`Token ${symbol} fetch error:`, err.message);
            }
        });

        getConfigs().then(data => {
            setSession(SEASONS.find(s => s.id === data.session));
            setFee(data.fee);
        }).catch(err => {
            console.warn('getConfigs() failed:', err.message);
        });

        //fetchLowestPrices();
    }, []);

    useEffect(() => {
        fetchData();
        fetchMintInfo();
        const interval = setInterval(fetchData, 300000);
        return () => clearInterval(interval);
    }, [fetchData]);

    const grouped = {
        FARM: NFT_TEMPLATES.filter(n => n.type === 'Farm'),
        RANCH: NFT_TEMPLATES.filter(n => n.type === 'Ranch'),
        TOOL: NFT_TEMPLATES.filter(n => n.type === 'Tool'),
    };

    const groupedWorker = {
        FARM: WORKER_TEMPLATES.filter(w => w.type === 'Farm'),
        RANCH: WORKER_TEMPLATES.filter(w => w.type === 'Ranch'),
        TOOL: WORKER_TEMPLATES.filter(w => w.type === 'Tool'),
    };

    const getPackForWorker = (workerName) => {
        const tier = workerName.split(' ')[0]; // Bronze, Silver, vs
        return WORKER_PACK_TEMPLATES.find(p => p.pack_name.startsWith(tier));
    };

    return (
        <div className="page-container">
            <div className="warning-text">
                ⚠️ RanchersLand is a blockchain-based game for entertainment purposes only. It does not promise or guarantee any earnings, profits, or returns. Any in-game ROI, profit, or income estimates are purely informational and subject to change. By playing, you acknowledge all risks and agree that no financial outcomes are guaranteed. ⚠️
            </div>

            {fee !== null && session !== null && (
                <div className="info-bar">
                    <div className="season-info">
                        <span className="season-label">Season:</span>
                        <div className="season-info-content">
                            {session?.session_name.toUpperCase()}{' '}
                            {{
                                spring: '🌼',
                                summer: '☀️',
                                autumn: '🍂',
                                winter: '❄️',
                            }[session?.session_name] || ''}
                        </div>
                    </div>
                    <div className="fee-info">
                        <span className="fee-label">Fee:</span>
                        <div className={`fee-box fee-${fee}`}>%{fee}</div>
                        {waxpUsd !== null && (
                            <div className="waxp-price-info">
                                <span className="fee-label">WAXP/USDT:</span>
                                <div className="fee-box">${waxpUsd.toFixed(4)}</div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <WalletInput
                session={session}
                tokenData={tokenData}
            />

            <div className="group-wrapper">
                {Object.entries(grouped).map(([type, nfts]) => (
                    <div className="group-column" key={type}>
                        <div className="group-header">
                            <img src={TOKEN_INFO[type].icon} alt={type} className="token-icon" />
                            <span className="token-name">{type}</span>
                            <div className="token-wax-price">
                                <span>{tokenData[type]?.price ? Number(tokenData[type].price).toFixed(4) : '...'}</span>
                                <img src={waxpIcon} alt="WAXP" className="waxp-icon" />
                            </div>
                        </div>

                        <div className="token-info-block">
                            <div className="token-line">
                                <span><span className="daily-label">Vol 24h:</span> {tokenData[type]?.volume24 || '...'} WAX</span>
                                <span className={`token-change ${tokenData[type]?.change24 >= 0 ? 'pos' : 'neg'}`}>
                                    {tokenData[type]?.change24 ? `${tokenData[type].change24}%` : ''}
                                </span>
                            </div>
                            <div className="token-line">
                                <span><span className="daily-label">Vol 7d:</span> {tokenData[type]?.volume7d || '...'} WAX</span>
                                <span className={`token-change ${tokenData[type]?.change7d >= 0 ? 'pos' : 'neg'}`}>
                                    {tokenData[type]?.change7d ? `${tokenData[type].change7d}%` : ''}
                                </span>
                            </div>
                        </div>

                        {nfts.map(nft => (
                            <div className="nft-box" key={nft.template_id}>
                                <div className="nft-rows">
                                    <div className="nft-left">
                                        {nft.mints.map((mint, i) => {
                                            const [amount, symbol] = mint.split(' ');
                                            return (
                                                <div className="nft-cost-line cost-line" key={i}>
                                                    {parseFloat(amount).toFixed(2)}
                                                    <img src={TOKEN_INFO[symbol]?.icon} alt={symbol} className="token-mini" />
                                                </div>
                                            );
                                        })}
                                        <div className="nft-cost-line cost-line">
                                            {nft.mint_consume}
                                            <img src={require('../assets/icons/stamina.webp')} alt="stamina" className="token-mini" />
                                        </div>
                                        <div className="nft-craft-cost">Craft Cost:</div>
                                        <div className="nft-craft-cost-val">
                                            {(() => {
                                                let waxTotal = 0;
                                                nft.mints.forEach(mint => {
                                                    const [amountStr, symbol] = mint.split(' ');
                                                    const amount = parseFloat(amountStr);
                                                    const price = parseFloat(tokenData[symbol]?.price || 0);
                                                    waxTotal += amount * price;
                                                });
                                                if (session) {
                                                    const staminaCost = (nft.mint_consume * session.stamina_cost) / 100;
                                                    const staminaPrice = parseFloat(tokenData.TOOL?.price || 0);
                                                    waxTotal += staminaCost * staminaPrice;
                                                }
                                                return `${waxTotal.toFixed(2)} WAX`;
                                            })()}
                                        </div>
                                        <div className="nft-minted">Minted:</div>
                                        <div className="nft-minted-val">
                                            {mintInfo[nft.template_id] !== undefined ? mintInfo[nft.template_id] : '...'}
                                        </div>
                                    </div>

                                    <div className="nft-center">
                                        <img src={nft.img} alt={nft.nft_name} />
                                        <a
                                            className={`buy-button ${!lowestPrices[nft.template_id] ? 'disabled' : ''}`}
                                            href={lowestPrices[nft.template_id] ? getBuyUrl(nft.template_id) : '#'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => {
                                                if (!lowestPrices[nft.template_id]) e.preventDefault();
                                            }}
                                        >
                                            BUY
                                        </a>
                                    </div>


                                    <div className="nft-right">
                                        <div className="daily-label">Daily:</div>
                                        <div className={`daily-val ${(() => {
                                            if (!session || !tokenData.FARM || !tokenData.TOOL) return '';
                                            const [rewardAmountStr, rewardSymbol] = nft.rewards[0].split(' ');
                                            const rewardAmount = parseFloat(rewardAmountStr);
                                            const rewardTokenPrice = parseFloat(tokenData[rewardSymbol]?.price || 0);
                                            const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                            const durabilityPrice = parseFloat(tokenData.TOOL?.price || 0);
                                            const reward = rewardAmount * (session.reward_multiplier / 100) * rewardTokenPrice;
                                            const staminaCost = (nft.consumed.first * session.stamina_cost / 100) * staminaPrice;
                                            const durabilityCost = (nft.consumed.second * session.durability_cost / 100) * durabilityPrice;
                                            const profitPerClaim = reward - (staminaCost + durabilityCost);
                                            const cooldown = nft.charged_time * (session.cooldown_multiplier / 100);
                                            const claimsPerDay = 86400 / cooldown;
                                            const dailyProfit = profitPerClaim * claimsPerDay;
                                            return dailyProfit >= 0 ? 'positive' : 'negative';
                                        })()}`}>
                                            {(() => {
                                                if (!session || !tokenData.FARM || !tokenData.TOOL) return '...';
                                                const [rewardAmountStr, rewardSymbol] = nft.rewards[0].split(' ');
                                                const rewardAmount = parseFloat(rewardAmountStr);
                                                const rewardTokenPrice = parseFloat(tokenData[rewardSymbol]?.price || 0);
                                                const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                                const durabilityPrice = parseFloat(tokenData.TOOL?.price || 0);
                                                const reward = rewardAmount * (session.reward_multiplier / 100) * rewardTokenPrice;
                                                const staminaCost = (nft.consumed.first * session.stamina_cost / 100) * staminaPrice;
                                                const durabilityCost = (nft.consumed.second * session.durability_cost / 100) * durabilityPrice;
                                                const profitPerClaim = reward - (staminaCost + durabilityCost);
                                                const cooldown = nft.charged_time * (session.cooldown_multiplier / 100);
                                                const claimsPerDay = 86400 / cooldown;
                                                const dailyProfit = profitPerClaim * claimsPerDay;
                                                return `${dailyProfit.toFixed(2)} WAX`;
                                            })()}
                                        </div>

                                        <div className="roi-label">ROI:</div>
                                        <div className="roi-val">
                                            {(() => {
                                                if (!session || !tokenData.FARM || !tokenData.TOOL || !tokenData[nft.rewards[0].split(' ')[1]]) return '...';

                                                const [rewardAmountStr, rewardSymbol] = nft.rewards[0].split(' ');
                                                const rewardAmount = parseFloat(rewardAmountStr);
                                                const rewardTokenPrice = parseFloat(tokenData[rewardSymbol]?.price || 0);
                                                const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                                const durabilityPrice = parseFloat(tokenData.TOOL?.price || 0);

                                                const reward = rewardAmount * (session.reward_multiplier / 100) * rewardTokenPrice;
                                                const staminaCost = (nft.consumed.first * session.stamina_cost / 100) * staminaPrice;
                                                const durabilityCost = (nft.consumed.second * session.durability_cost / 100) * durabilityPrice;

                                                const profitPerClaim = reward - (staminaCost + durabilityCost);
                                                const cooldown = nft.charged_time * (session.cooldown_multiplier / 100);
                                                const claimsPerDay = 86400 / cooldown;
                                                const dailyProfit = profitPerClaim * claimsPerDay;

                                                let craftCost = 0;
                                                nft.mints.forEach(mint => {
                                                    const [amountStr, symbol] = mint.split(' ');
                                                    const amount = parseFloat(amountStr);
                                                    const price = parseFloat(tokenData[symbol]?.price || 0);
                                                    craftCost += amount * price;
                                                });
                                                const staminaCostTotal = (nft.mint_consume * session.stamina_cost / 100) * parseFloat(tokenData.TOOL?.price || 0);
                                                craftCost += staminaCostTotal;

                                                const marketCost = lowestPrices[nft.template_id];
                                                const usedCost = marketCost && marketCost < craftCost ? marketCost : craftCost;

                                                if (dailyProfit <= 0) return '-';
                                                const roiDays = usedCost / dailyProfit;
                                                return isFinite(roiDays) ? `${roiDays.toFixed(1)} days` : '...';
                                            })()}
                                        </div>
                                        <div className="market-label">Atomic Lowest:</div>
                                        <div className="market-val">
                                            {lowestPrices[nft.template_id] ? `${lowestPrices[nft.template_id].toFixed(2)} WAX` : '...'}
                                        </div>

                                        <div className="token-label">Token:</div>
                                        <div className="token-val">
                                            {(() => {
                                                const [amount, symbol] = nft.rewards[0].split(' ');
                                                return (
                                                    <>
                                                        {parseFloat(amount).toFixed(2)}
                                                        <img src={TOKEN_INFO[symbol]?.icon} alt={symbol} className="token-mini ml-4" />
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                {tokenData.RCOIN && (
                    <div className="rcoin-bar">
                        <div className="group-header rcoin-header">
                            <img src={rcoinIcon} alt="RCOIN" className="token-icon" />
                            <span className="token-name">RCOIN</span>
                            <div className="token-wax-price">
                                <span>{parseFloat(tokenData.RCOIN.price).toFixed(4)}</span>
                                <img src={waxpIcon} alt="WAXP" className="waxp-icon" />
                            </div>
                        </div>

                        <div className="token-info-block rcoin-info-block">
                            <div className="token-line">
                                <span><span className="daily-label">Vol 24h:</span> {tokenData.RCOIN.volume24} WAX</span>
                                <span className={`token-change ${tokenData.RCOIN.change24 >= 0 ? 'pos' : 'neg'}`}>
                                    {tokenData.RCOIN.change24}%
                                </span>
                            </div>
                            <div className="token-line">
                                <span><span className="daily-label">Vol 7d:</span> {tokenData.RCOIN.volume7d} WAX</span>
                                <span className={`token-change ${tokenData.RCOIN.change7d >= 0 ? 'pos' : 'neg'}`}>
                                    {tokenData.RCOIN.change7d}%
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                {Object.entries(groupedWorker).map(([type, workers]) => (
                    <div className="group-column" key={type + '-workers'}>
                        <div className="group-header">
                            <img src={TOKEN_INFO[type].icon} alt={type} className="token-icon" />
                            <span className="token-name">{type} Workers</span>
                        </div>
                        {workers.map(worker => {
                            const pack = getPackForWorker(worker.worker_name);
                            const [toolAmount] = pack.mint_cost.first.split(' ');
                            const [rcoinAmount] = pack.mint_cost.second.split(' ');
                            const toolPrice = parseFloat(tokenData.TOOL?.price || 0);
                            const rcoinPrice = parseFloat(tokenData.RCOIN?.price || 0);
                            const craftCost = toolPrice * parseFloat(toolAmount) + rcoinPrice * parseFloat(rcoinAmount);
                            const staminaCost = (pack.mint_consume * session?.stamina_cost / 100) * toolPrice;
                            const totalCost = craftCost + staminaCost;
                            const lowest = lowestPrices[worker.template_id];

                            return (
                                <div className="nft-box" key={worker.template_id}>
                                    <div className="nft-rows">
                                        <div className="nft-left">
                                            <div className="nft-cost-line cost-line">
                                                {parseFloat(toolAmount).toFixed(2)}
                                                <img src={toolIcon} className="token-mini" alt="TOOL" />
                                            </div>
                                            <div className="nft-cost-line cost-line">
                                                {parseFloat(rcoinAmount).toFixed(2)}
                                                <img src={rcoinIcon} className="token-mini" alt="RCOIN" />
                                            </div>
                                            <div className="nft-cost-line cost-line">
                                                {pack.mint_consume}
                                                <img src={require('../assets/icons/stamina.webp')} className="token-mini" alt="Stamina" />
                                            </div>

                                            <div className="nft-craft-cost">Craft Cost:</div>
                                            <div className="nft-craft-cost-val">{totalCost.toFixed(2)} WAX</div>

                                            <div className="nft-minted">Minted:</div>
                                            <div className="nft-minted-val">
                                                {mintInfo[worker.template_id] !== undefined ? mintInfo[worker.template_id] : '...'}
                                            </div>
                                        </div>

                                        <div className="nft-center">
                                            <img src={worker.img} alt={worker.worker_name} />
                                            <a
                                                className={`buy-button ${!lowest ? 'disabled' : ''}`}
                                                href={lowest ? getBuyUrl(worker.template_id, 'workers') : '#'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    if (!lowest) e.preventDefault();
                                                }}
                                            >
                                                BUY
                                            </a>
                                        </div>

                                        <div className="nft-right">
                                            <div className="daily-label">Daily:</div>
                                            <div className={`daily-val ${(() => {
                                                if (!session || !tokenData.RCOIN?.price || !worker.reward) return '';
                                                const rewardPerClaim = worker.reward * (session.reward_multiplier / 100) * parseFloat(tokenData.RCOIN.price);
                                                const cooldown = worker.charged_time * (session.cooldown_multiplier / 100);
                                                const claimsPerDay = 86400 / cooldown;
                                                const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                                const staminaCost = (100 * session.stamina_cost / 100) * staminaPrice;
                                                const dailyProfit = (rewardPerClaim - staminaCost) * claimsPerDay;
                                                return dailyProfit >= 0 ? 'positive' : 'negative';
                                            })()}`}>
                                                {(() => {
                                                    if (!session || !tokenData.RCOIN?.price || !worker.reward) return '...';
                                                    const rewardPerClaim = worker.reward * (session.reward_multiplier / 100) * parseFloat(tokenData.RCOIN.price);
                                                    const cooldown = worker.charged_time * (session.cooldown_multiplier / 100);
                                                    const claimsPerDay = 86400 / cooldown;
                                                    const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                                    const staminaCost = (100 * session.stamina_cost / 100) * staminaPrice;
                                                    const dailyProfit = (rewardPerClaim - staminaCost) * claimsPerDay;
                                                    return `${dailyProfit.toFixed(2)} WAX`;
                                                })()}
                                            </div>

                                            <div className="roi-label">ROI:</div>
                                            <div className="roi-val">
                                                {(() => {
                                                    if (!session || !tokenData.RCOIN?.price || !worker.reward) return '...';
                                                    const rewardPerClaim = worker.reward * (session.reward_multiplier / 100) * parseFloat(tokenData.RCOIN.price);
                                                    const cooldown = worker.charged_time * (session.cooldown_multiplier / 100);
                                                    const claimsPerDay = 86400 / cooldown;
                                                    const staminaPrice = parseFloat(tokenData.FARM?.price || 0);
                                                    const staminaCost = (100 * session.stamina_cost / 100) * staminaPrice;
                                                    const dailyProfit = (rewardPerClaim - staminaCost) * claimsPerDay;

                                                    const usedCost = lowest && lowest < totalCost ? lowest : totalCost;

                                                    if (dailyProfit <= 0) return '-';
                                                    return isFinite(usedCost / dailyProfit) ? `${(usedCost / dailyProfit).toFixed(1)} days` : '...';
                                                })()}
                                            </div>

                                            <div className="market-label">Atomic Lowest:</div>
                                            <div className="market-val">{lowest ? `${lowest.toFixed(2)} WAX` : '...'}</div>

                                            <div className="token-label">Token:</div>
                                            <div className="token-val">
                                                {(() => {
                                                    const rewards = worker.rewards_rate;
                                                    if (!Array.isArray(rewards) || rewards.length === 0) return '...';
                                                    const first = parseFloat(rewards[0]).toFixed(2);
                                                    const last = parseFloat(rewards[rewards.length - 1]).toFixed(2);
                                                    return `${first} - ${last}`;
                                                })()}
                                                <img src={rcoinIcon} className="token-mini ml-4" alt="RCOIN" />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
            <div className="warning-text-bottom">
                ⚠️ RanchersLand is a blockchain-based game for entertainment purposes only. It does not promise or guarantee any earnings, profits, or returns. Any in-game ROI, profit, or income estimates are purely informational and subject to change. By playing, you acknowledge all risks and agree that no financial outcomes are guaranteed. ⚠️
            </div>
        </div>
    );
}
